import { useDataChange } from 'Simple/Data.js'
export function useOnClick(props) {
  let change = useDataChange({
    context: 'event_action',
    viewPath: props.viewPath,
  })
  return function onClick() {
    change(next => {
      next.data.type = 'after'
      next.data.event = 'automation_triggered'
    })
  }
}
